let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("cOS2O")]).then(() => parcelRequire('8FBSU'));